import { IWishlistButtonProps } from '@awaze/design-system.compositions.property-card'
import { WishlistButton } from '@awaze/design-system.components.wishlist-button'

export const ConditionalWishlistButton = ({
  label,
  wishlistButton = {
    showWishlistButton: false,
    isPropertyInWishlist: false,
    toggleWishlistItem: () => {},
  },
}: {
  label?: string
  wishlistButton?: IWishlistButtonProps
}) => {
  if (!wishlistButton.showWishlistButton) return null

  return (
    <WishlistButton
      label={label ?? ''}
      isChecked={wishlistButton.isPropertyInWishlist}
      showLabel={false}
      variant="elevated"
      buttonSize={wishlistButton.buttonSize}
      throttleDuration={wishlistButton.throttleDuration}
      onClickCallback={wishlistButton.toggleWishlistItem}
    />
  )
}
